import React, { Component } from 'react';
import { Box, Typography } from '@mui/material';
import i18n from '../../i18n';

class TextDetails extends Component {
    // props: value
    render() {
        return (
            <Box sx={{ m: 1 }}>
                <Typography variant="subtitle1">
                    {i18n.t(`columns.${this.props.label}`)}
                </Typography>
                <Typography variant="body1">
                    {' '}
                    {this.props.value
                        ? this.props.value
                        : i18n.t('text.noData')}{' '}
                </Typography>
            </Box>
        );
    }
}

export default TextDetails;
